import { SVGProps } from "react";

function EmailsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      id="email"
      {...props}
    >
      <path d="M5,57H53a3.00328,3.00328,0,0,0,3-3V31.7998a2.00021,2.00021,0,0,0-4,.00009V50.74976L36.68457,39.26318l2.55762-1.32812a2.00023,2.00023,0,0,0-1.84383-3.54977L29.001,38.74609,6,26.78571V23H30a2.00021,2.00021,0,0,0-.00009-4H5a3.00328,3.00328,0,0,0-3,3V54A3.00328,3.00328,0,0,0,5,57ZM29,43c.69879.09848,3.10605-1.43013,3.745-1.691L48.333,53H9.667L25.25665,41.30774C25.90719,41.57433,28.28543,43.09268,29,43Zm-7.68073-3.73969L6,50.74976V31.29431Z"></path>
      <path d="M48 7c-18.57194.7685-18.56853 27.23345.00011 28a2.00021 2.00021 0 0 0-.00019-4A10.01144 10.01144 0 0 1 38 21c.54952-13.26614 19.45236-13.26273 20 .00008L58 22a2 2 0 0 1-4 0V21c-.28034-7.93971-11.71973-7.94008-12 .0001a6.02565 6.02565 0 0 0 9.45027 4.90052c3.4697 4.19576 10.61733 1.61413 10.54968-3.90078A14.09512 14.09512 0 0 0 48 7zm0 16a2.00021 2.00021 0 0 1 .00009-4A2.00021 2.00021 0 0 1 48 23zM27 33a2.00022 2.00022 0 0 0 4-.00009A2.00022 2.00022 0 0 0 27 33z"></path>
    </svg>
  );
}

export default EmailsIcon;
